(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["moise-channel"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.ChannelIO || window.Shopify?.designMode) return;
  const channel = function () { channel.c(arguments); };
  channel.q = [];
  channel.c = function (args) { channel.q.push(args); };
  window.ChannelIO = channel;
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://cdn.channel.io/plugin/ch-plugin-web.js';
  document.head.appendChild(script);
  const language = document.documentElement.lang.split('-')[0];
  const uiLanguage = ['ko','en','ja'].includes(language) ? language : 'en';
  let bootFailed = false;
  let ready = false;
  let openRequested = false;
  document.querySelector('[data-moise-chat-link]')?.addEventListener('click', event => {
    if (bootFailed) return;
    event.preventDefault();
    openRequested = true;
    if (ready) window.ChannelIO('showMessenger');
  });
  channel('boot',Object.assign({pluginKey:'3503b922-0519-4393-a01d-79aa3b4c5da8',language:uiLanguage,mobileMessengerMode:'iframe',hidePopup:true,hideChannelButtonOnBoot:true,zIndex:9999},window.MOISE_CH_MEMBER||{}),error=>{
    if (error) { bootFailed = true; console.warn('MOISĒ chat is temporarily unavailable.'); return; }
    ready = true;
    window.ChannelIO('updateUser', { language: uiLanguage });
    if (openRequested) window.ChannelIO('showMessenger');
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["moise-imported-reviews"] && !Shopify.designMode) return;
  try {
    (function () {
  var LABELS = {
    ko: { all: '전체', photo: '포토 리뷰', more: '리뷰 더보기', reviews: '개 리뷰', readmore: '더보기', fold: '접기', wadiz: '와디즈 펀딩 구매', naver: '네이버페이 구매', trial: '체험단', rebuy: '재구매', month: '한달 사용' },
    en: { all: 'All', photo: 'Photo reviews', more: 'More reviews', reviews: ' reviews', readmore: 'Read more', fold: 'Show less', wadiz: 'Wadiz backer', naver: 'Naver Pay purchase', trial: 'Free sample review', rebuy: 'Repurchase', month: '1-month use' },
    ja: { all: 'すべて', photo: 'フォトレビュー', more: 'もっと見る', reviews: '件のレビュー', readmore: '続きを読む', fold: '閉じる', wadiz: 'Wadiz購入', naver: 'NAVER Pay購入', trial: 'モニター提供', rebuy: 'リピート購入', month: '1ヶ月使用' }
  };
  var PAGE = 10;
  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }
  function stars(n) { var s = ''; for (var i = 1; i <= 5; i++) s += i <= Math.round(n) ? '★' : '☆'; return s; }
  function fmt(n) { return Number(n).toLocaleString(); }

  function render(root, d, t) {
    var base = d.img_base, all = d.reviews;
    var list = root.querySelector('[data-mr-list]');
    var more = root.querySelector('[data-mr-more]');
    var lb = root.querySelector('[data-mr-lightbox]');
    var lbimg = root.querySelector('[data-mr-lbimg]');
    var tabsWrap = root.querySelector('[data-mr-tabs]');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-mr-filter]'));

    root.querySelector('[data-mr-avg]').textContent = Number(d.avg).toFixed(1);
    root.querySelector('[data-mr-avgstars]').textContent = stars(d.avg);
    root.querySelector('[data-mr-total]').textContent = fmt(d.count) + t.reviews;
    var dist = root.querySelector('[data-mr-dist]');
    d.dist.forEach(function (c, i) {
      var li = el('li');
      li.appendChild(el('span', null, (5 - i) + '★'));
      var bar = el('span', 'mr-bar'); var fill = el('i');
      fill.style.width = (d.count ? (c / d.count) * 100 : 0) + '%';
      bar.appendChild(fill); li.appendChild(bar);
      li.appendChild(el('span', null, fmt(c)));
      dist.appendChild(li);
    });
    root.querySelector('[data-mr-summary]').hidden = false;

    function openImg(src) { lbimg.src = src; if (lb.showModal) lb.showModal(); else window.open(src, '_blank', 'noopener'); }
    root.querySelector('[data-mr-close]').addEventListener('click', function () { lb.close(); });
    lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });

    function thumb(name) {
      var b = el('button'); b.type = 'button';
      var im = el('img'); im.loading = 'lazy'; im.decoding = 'async'; im.alt = ''; im.src = base + name;
      b.appendChild(im);
      b.addEventListener('click', function () { openImg(base + name); });
      return b;
    }

    var photos = [], extra = [];
    all.forEach(function (r) { r.i.forEach(function (n, k) { (k === 0 ? photos : extra).push(n); }); });
    photos = photos.concat(extra);
    var strip = root.querySelector('[data-mr-strip]');
    var max = window.matchMedia('(max-width: 749px)').matches ? 8 : 16;
    photos.slice(0, max).forEach(function (n, idx) {
      if (idx === max - 1 && photos.length > max) {
        var b = el('button'); b.type = 'button';
        var im = el('img'); im.loading = 'lazy'; im.alt = ''; im.src = base + n; b.appendChild(im);
        b.appendChild(el('span', 'mr-plus', '+' + fmt(photos.length - max + 1)));
        b.addEventListener('click', function () { setFilter('photo'); tabsWrap.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
        strip.appendChild(b);
      } else {
        strip.appendChild(thumb(n));
      }
    });
    if (photos.length) strip.hidden = false;

    tabs[0].textContent = t.all + ' ' + fmt(d.count);
    tabs[1].textContent = t.photo + ' ' + fmt(d.photo_count);
    tabsWrap.hidden = false;

    var cur = all, shown = 0;
    function card(r) {
      var c = el('article', 'mr-card'); c.lang = 'ko';
      var m = el('div', 'mr-meta');
      m.appendChild(el('span', 'mr-stars', stars(r.r)));
      if (r.n) m.appendChild(el('span', null, r.n));
      var chips = [];
      if (r.t) chips.push(t.trial); else if (r.s === 'wadiz') chips.push(t.wadiz); else if (r.s === 'naver') chips.push(t.naver);
      (r.g || []).forEach(function (g) { if (g === '재구매') chips.push(t.rebuy); if (g === '한달사용기') chips.push(t.month); });
      chips.forEach(function (x) { m.appendChild(el('span', 'mr-chip', x)); });
      c.appendChild(m);
      if (r.b) {
        var p = el('p', 'mr-body', r.b); c.appendChild(p);
        if (r.b.length > 150 || r.b.split('\n').length > 4) {
          p.classList.add('is-clamped');
          var tg = el('button', 'mr-toggle', t.readmore); tg.type = 'button';
          tg.addEventListener('click', function () { var closed = p.classList.toggle('is-clamped'); tg.textContent = closed ? t.readmore : t.fold; });
          c.appendChild(tg);
        }
      }
      if (r.i.length) { var ph = el('div', 'mr-photos'); r.i.forEach(function (n) { ph.appendChild(thumb(n)); }); c.appendChild(ph); }
      return c;
    }
    function nextPage() {
      cur.slice(shown, shown + PAGE).forEach(function (r) { list.appendChild(card(r)); });
      shown += PAGE;
      more.hidden = shown >= cur.length;
      more.textContent = t.more + ' +';
    }
    function setFilter(f) {
      cur = f === 'photo' ? all.filter(function (r) { return r.i.length; }) : all;
      shown = 0; list.innerHTML = '';
      tabs.forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-mr-filter') === f ? 'true' : 'false'); });
      nextPage();
    }
    tabs.forEach(function (b) { b.addEventListener('click', function () { setFilter(b.getAttribute('data-mr-filter')); }); });
    more.addEventListener('click', nextPage);
    setFilter('all');
  }

  function init(root) {
    if (root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', '1');
    var lang = (root.getAttribute('data-lang') || 'en').slice(0, 2);
    var t = LABELS[lang] || LABELS.en;
    fetch(root.getAttribute('data-src'))
      .then(function (r) { return r.json(); })
      .then(function (d) { render(root, d, t); })
      .catch(function () { root.hidden = true; });
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('#moise-reviews'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["moise-join-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
  document.querySelectorAll('.moise-join-menu[open]').forEach(menu=>{
    if(!menu.contains(event.target)||event.target.closest('[data-me-open]'))menu.open=false;
  });
});
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.moise-join-menu[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});});
  } catch(e) { console.error(e); }
})();

})();
